/**
 * API Configuration
 */

export const API_CONFIG = {
  // Base API URL from environment or default
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',

  // Request timeout in milliseconds
  TIMEOUT: 30000,

  // Retry configuration
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000, // Initial delay in ms
    BACKOFF_MULTIPLIER: 2, // Exponential backoff multiplier
    RETRYABLE_STATUS_CODES: [408, 429, 500, 502, 503, 504],
  },

  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },

  // Cache configuration
  CACHE: {
    ENABLED: false,
    TTL: 5 * 60 * 1000, // 5 minutes
  },
};
